import _defineProperty from '@babel/runtime/helpers/defineProperty';
import classnames from 'classnames';
import React__default from 'react';
import Card from '../../../Card.js';
import { getHasRowGroup } from '../utils/columnUtils.js';
import ColumnList from './Column/ColumnList.js';
import ColumnManagerSearch from './ColumnManagerSearch.js';
import { useColumnManager } from './context/ColumnManagerContext.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ColumnManager = function ColumnManager(_ref) {
  var dataTestId = _ref.dataTestId,
    isOpen = _ref.isVisible,
    location = _ref.location,
    size = _ref.size;
    _ref.allowSorting;
    var allowPinning = _ref.allowPinning,
    className = _ref.className;
  var _useColumnManager = useColumnManager(),
    columnDefs = _useColumnManager.columnDefs,
    updateColumnDefs = _useColumnManager.updateColumnDefs;
  var finalClasses = classnames('C-ColumnManager', _defineProperty(_defineProperty({
    isVisible: isOpen
  }, "--size-".concat(size), size), "--location-".concat(location), location), className);
  var handleSearchText = function handleSearchText(e) {
    var value = e.target.value;
    updateColumnDefs(function (prev) {
      return prev.map(function (c) {
        return _objectSpread(_objectSpread({}, c), {}, {
          isFiltered: c.headerName.toLowerCase().includes(value.toLowerCase())
        });
      });
    });
  };
  var handleReorder = function handleReorder(columns) {
    return updateColumnDefs(function () {
      return columns;
    });
  };
  var hasRowGroup = getHasRowGroup(columnDefs);
  var hasSearchText = columnDefs.some(function (c) {
    return c.isFiltered === false;
  });
  return /*#__PURE__*/React__default.createElement(Card, {
    className: finalClasses
  }, /*#__PURE__*/React__default.createElement(ColumnManagerSearch, {
    onChange: handleSearchText
  }), /*#__PURE__*/React__default.createElement(ColumnList, {
    dataTestId: "".concat(dataTestId, "_list"),
    allowPinning: hasRowGroup ? false : allowPinning,
    disableReorder: hasSearchText,
    columns: columnDefs,
    onReorder: handleReorder
  }));
};

export { ColumnManager as default };
